<template >
    <div class="detail">
        
      <Grid
        ref="item"
        :style="{ height: 'auto' }"
        :columns="columns"
        :data-items="dataItem.configurationData"
      ></Grid>

    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        columns: [
          {
            hidden: false,
            field: "configuration",
            cell:this.rawData,
            title: "Configuration",
            width:"auto",
            checked: true,
            defaultSelected: true,
          },
      
        ],
      };
    },
    props: {
      dataItem: Object,
    },
    
    methods: {
      rawData:function(h,tdElement,props){
       const field = props.field;
        var value = props.dataItem[field];
        if (!value) {
          return h("td", {}, "null");
        }
        let mapObj = {
          "{" : " ",
          "}" : " ",
        }
        let res =  value.replace(/{|}/g , function(matched){
          return mapObj[matched]
        })
        return h("td", {}, res );
      },
  
    },
  };
  </script>
  <style >
  .k-grid th, .k-grid td {
      word-break: break-word;
  }
  </style>